import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Adb2cService } from '@app/blocks/adb2c/services/adb2c/adb2c.service';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { ConfigurationService } from '@app/core/shell/services/configuration.service';
import { Application } from '@app/shared/models/Application.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApplicationStatusService {

    constructor(
        private logger: LoggerService,
        private adb2cService: Adb2cService,
        private configService: ConfigurationService,
        private http: HttpClient
    ) { }

    getApplicationStatus(isTenant: boolean, sub: string): any {
        const applicationApiUrl = this.configService.getConfig()?.shell.api.applicationApiUrl;

        const url = applicationApiUrl + 'applicationstatus/' + sub + '?tenant=' + isTenant;
        // const url = 'https://localhost:7004/' + 'applicationstatus/' + '7affef7b-daea-4adb-b951-f0211ce01e62' + '?tenant=' + isTenant;
        this.logger.info('url', url);

        const result = firstValueFrom(this.http.get<any>(url));
        console.log("Application Status data", result);
        return result;
    }

    withdrawApplication(applicationId: string): any {
        const applicationApiUrl = this.configService.getConfig()?.shell.api.applicationApiUrl;
        const url = applicationApiUrl + 'applicationstatus/' + applicationId;
        this.logger.info('url', url);

        return firstValueFrom(this.http.put<any>(url, {}, { headers: { "Content-Type": "application/json; charset=UTF-8" } }));
    }

    formatApplications(applications: Application[], signup: string) {
        const formattedApplications: any[] = [];

        applications.forEach(app => {
            const formattedApplication: any = {
                "addressLine1": app.addressLine1,
                "applicationId": app.applicationId,
                "crmReference": app.crmReference,
                "liveApplications": app.liveApplications,
                "postCode": app.postCode,
                "status": app.status
            };

            switch (formattedApplication.status) {
                case 'Approved':
                    formattedApplication.statusClass = "label-success";
                    formattedApplication.showApply = true;
                    formattedApplication.applyButtonText = "Complete Application";
                    formattedApplication.applyButtonUrl = "/sign-up/complete-application-introduction/";
                    formattedApplication.showWithdraw = true;
                    break;
                case 'Payment Submitted':
                    formattedApplication.statusClass = "label-success";
                    formattedApplication.showApply = false;
                    // formattedApplication.status = formattedApplication.status;
                    formattedApplication.showWithdraw = false;
                    break;
                case 'Pending Approval':
                    formattedApplication.statusClass = "label-warning";
                    formattedApplication.showApply = false;
                    // formattedApplication.status = formattedApplication.status;
                    formattedApplication.showWithdraw = true;
                    break;
                case 'Pending Additional Details':
                case 'Pending Payment':
                    formattedApplication.statusClass = "label-warning";
                    formattedApplication.showApply = true;
                    // formattedApplication.status = formattedApplication.status;
                    formattedApplication.applyButtonText = "Complete Application";
                    formattedApplication.applyButtonUrl = "/sign-up/complete-application/";
                    formattedApplication.showWithdraw = true;
                    break;
                case 'Not Started':
                    formattedApplication.statusClass = "label-warning";
                    formattedApplication.showApply = true;
                    formattedApplication.applyButtonUrl = "/core-application-requirements/";
                    formattedApplication.applyButtonText = "Apply";
                    formattedApplication.showWithdraw = true;
                    break;
                case 'Unsuccessful':
                    formattedApplication.statusClass = "label-danger";
                    formattedApplication.showApply = false;
                    formattedApplication.showWithdraw = false;
                    break;
                case 'In Progress':
                    formattedApplication.statusClass = "label-primary";
                    formattedApplication.applyButtonText = "Continue Application";
                    formattedApplication.applyButtonUrl = "/application/";
                    formattedApplication.showApply = true;
                    formattedApplication.showWithdraw = true;
                    break;
                default:
                    formattedApplication.statusClass = "label-default";
                    formattedApplication.showApply = false;
                    formattedApplication.showWithdraw = false;
            }

            // Hide apply button for signup if turned off
            if (signup === "false" &&
                (formattedApplication.status === "Approved" || formattedApplication.status === "Pending Additional Details")) {
                formattedApplication.showApply = false;
            }

            formattedApplications.push(formattedApplication);
        })

        return formattedApplications;
    }
}
